export interface ErrorInfo {
  title: string;
  message: string;
  showRetryButton?: boolean;
  severity: 'error' | 'warning' | 'info';
}

export const getErrorInfo = (error: any): ErrorInfo => {
  // Check if it's an axios error with response
  if (error?.response?.status) {
    const status = error.response.status;
    const data = error.response.data;
    
    // Check for rate limiting (429) or specific error messages
    if (status === 429 || 
        (data && typeof data === 'object' && data['Error Message'] && 
         data['Error Message'].includes('Limit Reach'))) {
      return {
        title: 'Service Temporarily Unavailable',
        message: 'Our data provider is currently experiencing high traffic. Please try again in a few minutes.',
        showRetryButton: true,
        severity: 'warning'
      };
    }
    
    // Check for server errors (5xx)
    if (status >= 500) {
      return {
        title: 'Service Temporarily Unavailable',
        message: 'We\'re experiencing technical difficulties. Please try again in a few minutes.',
        showRetryButton: true,
        severity: 'error'
      };
    }
    
    // Check for not found (404)
    if (status === 404) {
      return {
        title: 'Data Not Available',
        message: 'The requested information is not currently available. Please try again later or contact support if the issue persists.',
        showRetryButton: true,
        severity: 'info'
      };
    }
    
    // Check for client errors (4xx)
    if (status >= 400) {
      return {
        title: 'Unable to Load Data',
        message: 'There was an issue with your request. Please try again or refresh the page.',
        showRetryButton: true,
        severity: 'warning'
      };
    }
  }
  
  // Check for network errors
  if (error?.message?.includes('Network Error') || 
      error?.message?.includes('timeout') ||
      error?.code === 'NETWORK_ERROR') {
    return {
      title: 'Connection Issue',
      message: 'Unable to connect to our servers. Please check your internet connection and try again.',
      showRetryButton: true,
      severity: 'warning'
    };
  }
  
  // Default fallback for any other errors
  return {
    title: 'Something Went Wrong',
    message: 'We encountered an unexpected issue. Please try again in a few minutes.',
    showRetryButton: true,
    severity: 'error'
  };
};